export default __webpack_public_path__ + "static/media/swetha.f0ad7e09.jpg";